// Default locale de-DE, thousand separator is a dot(123.321)
export const formatNumberString = (value: number, stringLocale = 'en-US') =>
  value?.toLocaleString(stringLocale) ?? '–';
